var BusinessFormClickActions;
(function (BusinessFormClickActions) {
    BusinessFormClickActions["nextStep"] = "nextStep";
    BusinessFormClickActions["previousStep"] = "previousStep";
    BusinessFormClickActions["submit"] = "submit";
    BusinessFormClickActions["removeOwner"] = "removeOwner";
    BusinessFormClickActions["addOwner"] = "addOwner";
    BusinessFormClickActions["addOwnerForm"] = "addOwnerForm";
    BusinessFormClickActions["updateOwner"] = "updateOwner";
})(BusinessFormClickActions || (BusinessFormClickActions = {}));
var BusinessFormStep;
(function (BusinessFormStep) {
    BusinessFormStep["businessInfo"] = "business_info";
    BusinessFormStep["legalAddress"] = "legal_address";
    BusinessFormStep["additionalQuestions"] = "additional_questions";
    BusinessFormStep["representative"] = "representative";
    BusinessFormStep["owners"] = "owners";
    BusinessFormStep["bankAccount"] = "bank_account";
    BusinessFormStep["documentUpload"] = "document_upload";
    BusinessFormStep["termsAndConditions"] = "terms_and_conditions";
})(BusinessFormStep || (BusinessFormStep = {}));

export { BusinessFormStep as B, BusinessFormClickActions as a };
